import { tracked } from "@glimmer/tracking";
import { action } from "@ember/object";
import { getOwner, setOwner } from "@ember/owner";
import { service } from "@ember/service";
import { uniqueItemsFromArray } from "discourse/lib/array-tools";
import { NotificationLevels } from "discourse/lib/notification-levels";
import { autoTrackedArray } from "discourse/lib/tracked-tools";
import Topic from "discourse/models/topic";

export default class BulkSelectHelper {
  @service router;
  @service modal;
  @service pmTopicTrackingState;
  @service topicTrackingState;

  @tracked bulkSelectEnabled = false;
  @tracked autoAddTopicsToBulkSelect = false;
  @tracked autoAddBookmarksToBulkSelect = false;
  @tracked lastCheckedElementId = null;

  @autoTrackedArray selected;

  constructor(context, topics) {
    if (topics) {
      this.selected = topics;
    } else {
      this.selected = [];
    }
    setOwner(this, getOwner(context));
  }

  clear() {
    this.selected.length = 0;
    this.lastCheckedElementId = null;
  }

  addTopics(topics) {
    this.selected = this.selected.concat(topics);
  }

  setTopics(topics) {
    this.selected = topics;
  }

  get onBulkSelectToggle() {
    return this._onBulkSelectToggle;
  }

  set onBulkSelectToggle(callback) {
    this._onBulkSelectToggle = callback;
  }

  get onResetNew() {
    return this._onResetNew;
  }

  set onResetNew(callback) {
    this._onResetNew = callback;
  }

  get selectedCategoryIds() {
    return uniqueItemsFromArray(this.selected.map((item) => item.category_id));
  }

  @action
  toggleBulkSelect(event) {
    event?.preventDefault();
    this._onBulkSelectToggle?.(this.bulkSelectEnabled);
    this.bulkSelectEnabled = !this.bulkSelectEnabled;
    this.clear();
  }

  dismissRead(operationType, options) {
    const operation =
      operationType === "posts"
        ? { type: "dismiss_posts" }
        : {
            type: "change_notification_level",
            notification_level_id: NotificationLevels.REGULAR,
          };

    const isTracked =
      (this.router.currentRoute.queryParams["f"] ||
        this.router.currentRoute.queryParams["filter"]) === "tracked";

    const promise = this.selected.length
      ? Topic.bulkOperation(this.selected, operation, {}, isTracked)
      : Topic.bulkOperationByFilter("unread", operation, options, isTracked);

    promise.then((result) => {
      if (result?.topic_ids) {
        if (options?.private_message_inbox) {
          this.pmTopicTrackingState.removeTopics(result.topic_ids);
        } else {
          this.topicTrackingState.removeTopics(result.topic_ids);
        }
      }

      this.modal.close();
      this.router.refresh();
      this.bulkSelectEnabled = false;
      this.clear();
    });
  }
}
